import i18n from "i18next";
import type { InitOptions } from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import { LANGUAGE_KEY, languageList } from "./redux/types";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    lng: localStorage.getItem(LANGUAGE_KEY) || "ru",
    supportedLngs: languageList,
  } as InitOptions);

export default i18n;
